import React, { useEffect, useState } from "react";
// import { Button } from '@material-ui/core';

// import Charts from './Charts';
import useRedux from "hooks/useRedux";

import * as accountActionsList from "account/account.duck";

import { Dialog } from "hooks/useDialog";
import Conclusions from "./Conclusions";
import InformationTable1 from "./ReportTables/InformationTable1";
import ComparativeReturnTable2 from "./ReportTables/ComparativeReturnTable2";
import ComparativeTerminalValueTable3 from "./ReportTables/ComparativeTerminalValueTable3";
import ComparativeMonthlyTable4 from "./ReportTables/ComparativeMonthlyTable4";
import Definitions from "./Definitions";

import { openConfirm } from "components/confirmBox/ConfirmBox";

import Divider from "@material-ui/core/Divider";
import Slider from "@material-ui/core/Slider";

import Preview from "portfolioEntryWizard/components/Preview";
import { hashHistory } from "browserHistory";

import moment from "moment";
import styled from "styled-components";
import { Button, CircularProgress } from "@material-ui/core";

import { getDateValues } from "portfolioEntryWizard/components/PortfolioValuesNew";

import {
  PrintOutlined as Print,
  DeleteForeverOutlined as Delete,
  Share,
} from "@material-ui/icons";

function getHeadingItem(label, value) {
  return (
    <div style={{ display: "flex", margin: 5 }}>
      <div
        style={{
          marginRight: 10,
          width: 130,
          fontWeight: "bold",
          textAlign: "right",
        }}
      >
        {label}:
      </div>
      <div>{value}</div>
    </div>
  );
}

const ReportHeading = styled.div`
  font-size: 30px;
  margin-bottom: 30px;
`;

const ReportData = styled.div`
  margin: 50px;
`;

const KeepTogether = styled.div`
  @media print {
    page-break-inside: avoid;
  }
`;
const NoPrint = styled.div`
  @media print {
    display: none !important;
  }
`;

const Reports = (props) => {
  const { portfolio, id, isGuid, onDateRangeChange, datesAvailable } = props;
  const portfolioData = portfolio.portfolio;

  const [{ portfolioEntry, account }, accountActions] = useRedux(
    accountActionsList
  );

  const [showDialog, showDialog_set] = useState(false);

  const [showDateChange, showDateChange_set] = useState(false);

  const [selectedSliderValues, selectedSliderValues_set] = useState([0, 0]);
  // const [datesAvailable, datesAvailable_set] = useState([]);
  const [marks, marks_set] = useState([]);

  if (portfolio.loading) {
    return <div>Loading...</div>;
  }

  useEffect(() => {
    datesAvailable.forEach((dateItem, index) => {
      if (index === 0 || index === datesAvailable.length - 1) {
        marks.push({
          value: index,
          label: dateItem.label + " " + dateItem.year,
        });
      } else if (dateItem.month === "01") {
        marks.push({ value: index, label: dateItem.year });
      }
    });
    marks_set([...marks]);

    var minVal =
      portfolioData.data.portfolioValues &&
      portfolioData.data.portfolioValues[0].key;
    var maxVal =
      portfolioData.data.portfolioValues &&
      portfolioData.data.portfolioValues[
        portfolioData.data.portfolioValues.length - 1
      ].key;

    selectedSliderValues_set([
      datesAvailable.indexOf(datesAvailable.find((e) => e.key === minVal)),
      datesAvailable.indexOf(datesAvailable.find((e) => e.key === maxVal)),
    ]);
  }, [datesAvailable]);

  var show = !portfolio.portfolio.data.isPreview;

  var startDate = moment(portfolio.reportData.portfolio.startDate ? portfolio.reportData.portfolio.startDate :
    `${portfolioData.data.startYear}-${portfolioData.data.startMonth}-${lastDay(
      portfolioData.data.startYear,
      portfolioData.data.startMonth
    )}`
  ).format("MMMM DD, YYYY");

  var endDate = moment(portfolio.reportData.portfolio.endDate ? portfolio.reportData.portfolio.endDate :
    `${portfolioData.data.endYear}-${portfolioData.data.endMonth}-${lastDay(
      portfolioData.data.endYear,
      portfolioData.data.endMonth
    )}`
  ).format("MMMM DD, YYYY");

  function lastDay(y, m) {
    return new Date(y, m, 0).getDate();
  }

  return (
    <ReportData style={{ marginTop: 20 }}>
      <style>
        {`
            table{
                border: 1px solid black;
                border-collapse: collapse;
            }
            th, td {
                border: 1px solid black;
                padding: 5px 10px 5px 10px;
             }
            `}
      </style>
      <ReportHeading>Robo Portfolio Performance Analyzer Report</ReportHeading>
      <div style={{ display: "flex", marginBottom: 30 }}>
        <div style={{ width: "100%" }}>
          {!isGuid && getHeadingItem("Client", portfolioData.client)}
          {getHeadingItem("Portfolio Name", portfolioData.data.name)}
          {getHeadingItem("Currency", portfolioData.data.currencyType)}
          {getHeadingItem(
            "Report Date",
            moment.utc(portfolioData.date).format("MMMM Do, YYYY")
          )}
          {/* {getHeadingItem("Analysis Period", `${startDate} to ${endDate}`)} */}
          <div style={{ display: "flex", margin: 5 }}>
            <div
              style={{
                marginRight: 10,
                width: 130,
                fontWeight: "bold",
                textAlign: "right",
              }}
            >
              Analysis Period:
            </div>
            <div>{`${startDate} to ${endDate}`}</div>
            <NoPrint style={{ marginTop: -5 }}>
              <Button
                size={"small"}
                color="primary"
                onClick={() => {
                  showDateChange_set(true);
                }}
              >
                Modify
              </Button>
            </NoPrint>
          </div>
        </div>
        <NoPrint style={{ display: "flex", whiteSpace: "nowrap" }}>
          <div>
            <Button
              color={"primary"}
              onClick={() => {
                window.print();
              }}
            >
              <Print style={{ marginRight: 10 }} /> Print
            </Button>
          </div>
          {!isGuid && portfolioData.uniqueId && (
            <div>
              <Button
                color={"primary"}
                onClick={() => {
                  showDialog_set(true);
                }}
              >
                <Share style={{ marginRight: 10 }} /> Share
              </Button>
            </div>
          )}
          {showDateChange && (
            <div>
              <Dialog
                title={"Select Date Range"}
                options={{
                  maxWidth: "md",
                  fullWidth: true,
                }}
                actionButtons={[
                  <Button
                    variant={"text"}
                    color={"primary"}
                    onClick={() => {
                      var first = datesAvailable[selectedSliderValues[0]];
                      var last = datesAvailable[selectedSliderValues[1]];

                      onDateRangeChange(
                        first.month,
                        first.year,
                        last.month,
                        last.year
                      );
                      showDateChange_set(false);
                    }}
                  >
                    Apply Dates
                  </Button>,
                  <Button
                    variant={"text"}
                    color={"secondary"}
                    onClick={() => {
                      showDateChange_set(false);
                    }}
                  >
                    Cancel
                  </Button>,
                ]}
              >
                <div style={{ margin: "30px 20px" }}>
                  <Slider
                    min={0}
                    max={datesAvailable.length - 1}
                    value={selectedSliderValues}
                    onChange={(e, val) => {
                      //must have 8 months
                      if (val[1] - val[0] >= 8) {
                        selectedSliderValues_set(val);
                      }
                    }}
                    marks={marks}
                    valueLabelDisplay="on"
                    valueLabelFormat={(index) => {
                      var item = datesAvailable[index];
                      return item ? item.label : "";
                    }}
                  />
                </div>
                <div></div>
              </Dialog>
            </div>
          )}
          {showDialog && (
            <div>
              <Dialog
                title={"Public Link"}
                onClose={() => showDialog_set(false)}
              >
                <div style={{ fontSize: 14 }}>
                  <div>
                    Here is a direct link to your report. This link will allow
                    others to see this report. It is publicly available, so only
                    share it with those you trust.
                  </div>
                  <div
                    style={{ marginTop: 10, color: "#5a5aff" }}
                    id="linkCopy"
                  >{`${window.location.protocol}//${window.location.host}/#/Portfolio/${portfolioData.uniqueId}`}</div>
                  <div style={{ marginTop: 10 }}>
                    <Button
                      color={"primary"}
                      variant="outlined"
                      onClick={() => {
                        var range = document.createRange();
                        range.selectNode(document.getElementById("linkCopy"));
                        window.getSelection().removeAllRanges(); // clear current selection
                        window.getSelection().addRange(range); // to select text
                        document.execCommand("copy");
                        window.getSelection().removeAllRanges(); // to deselect
                      }}
                    >
                      Copy Link
                    </Button>
                  </div>
                </div>
              </Dialog>
            </div>
          )}

          {!isGuid && (
            <div>
              {portfolioEntry.copying && (
                <div>
                  <Dialog maxWidth="sm" fullWidth="true" actionButtons={[]}>
                    <div style={{ textAlign: "center", margin: 60 }}>
                      <div>
                        <CircularProgress />
                      </div>
                      <div>Copying...</div>
                    </div>
                  </Dialog>
                </div>
              )}
            </div>
          )}
          {!isGuid && (
            <div>
              <Button
                color={"primary"}
                onClick={() => {
                  openConfirm({
                    title: "Confirm Deletion",
                    description: (
                      <div>
                        <div>
                          Are you sure you want to permanently delete this
                          portfolio?
                        </div>
                        <div style={{ fontWeight: "bold", marginTop: 20 }}>
                          This cannot be undone.
                        </div>
                        <div style={{ marginTop: 20 }}>
                          Make sure to download a copy first by viewing the
                          report and printing it to a PDF file.
                        </div>
                      </div>
                    ),
                    callback: () => {
                      accountActions.deletePortfolio(id, null, () => {
                        localStorage.setItem("portfolioDeleted", true);
                        localStorage.removeItem("portfolioDeleted");

                        openConfirm({
                          title: "Completed",
                          isAlert: true,
                          description: (
                            <div>
                              <div>Your portfolio has been deleted.</div>
                            </div>
                          ),
                          callback: () => {
                            hashHistory.push("/Home");
                          },
                        });
                      });
                    },
                  });
                }}
              >
                <Delete style={{ marginRight: 10 }} /> Delete
              </Button>
              {account.portfolioDeleting && (
                <Dialog maxWidth="sm" fullWidth="true" actionButtons={[]}>
                  <div style={{ textAlign: "center", margin: 60 }}>
                    <div>
                      <CircularProgress />
                    </div>
                    <div>Deleting...</div>
                  </div>
                </Dialog>
              )}
            </div>
          )}
        </NoPrint>
      </div>
      <div></div>
      <Conclusions {...props} />
      {/* <NewPage> */}
      <KeepTogether>
        <div style={{ marginTop: 20 }}>
          <div style={{ fontSize: 26 }}>Appendix - Portfolio Inputs</div>
        </div>
        <div style={{ margin: 20 }}>
          <Preview {...{ ...props, portfolio: portfolioData.data }} />
        </div>
        <Divider />
      </KeepTogether>
      {show && (
        <KeepTogether>
          <KeepTogether>
            <div style={{ marginTop: 20 }}>
              <div style={{ fontSize: 26 }}>Appendix - Tables</div>
            </div>
            <div style={{ marginLeft: 20, marginTop: 40 }}>
              <InformationTable1 {...props} />
            </div>
          </KeepTogether>
          <KeepTogether>
            <div style={{ marginLeft: 20, marginTop: 40 }}>
              <ComparativeReturnTable2 {...props} />
            </div>
          </KeepTogether>
          <KeepTogether>
            <div style={{ marginLeft: 20, marginTop: 40 }}>
              <ComparativeTerminalValueTable3 {...props} />
            </div>
          </KeepTogether>
          <KeepTogether>
            <div style={{ marginLeft: 20, marginTop: 40, marginBottom: 10 }}>
              <ComparativeMonthlyTable4 {...props} />
            </div>
          </KeepTogether>
        </KeepTogether>
      )}
      {show && (
        <div>
          <Divider />
          <KeepTogether>
            <div style={{ marginTop: 20 }}>
              <div style={{ fontSize: 26 }}>
                Appendix – Definitions, in the approximate order they appear in
                your Report
              </div>
            </div>
            <div style={{ marginLeft: 20, marginTop: 40 }}>
              <Definitions />
            </div>
          </KeepTogether>
        </div>
      )}
      {/* </NewPage> */}
    </ReportData>
  );
};

export default Reports;



// WEBPACK FOOTER //
// ./src/portfolio/components/Reports.js